import { render, staticRenderFns } from "./content_container.vue?vue&type=template&id=1a451b84"
import script from "./content_container.vue?vue&type=script&lang=js"
export * from "./content_container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports